import React, { useState } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = ({
  phoneNumber = '6592398494', // GSK Geotech number (no + or spaces)
  message = 'Hello! I would like to know more about your geotechnical services.',
}) => {
  const [hovered, setHovered] = useState(false);

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab ${hovered ? 'hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Chat with us on WhatsApp"
    >
      {/* Tooltip */}
      <span className="whatsapp-fab__tooltip">Chat with us!</span>

      {/* Pulse ring */}
      <span className="whatsapp-fab__pulse" />

      {/* WhatsApp SVG icon */}
      <svg
        className="whatsapp-fab__icon"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        fill="white"
      >
        <path d="M16.003 2C8.28 2 2 8.28 2 16.003c0 2.47.658 4.842 1.902 6.915L2 30l7.338-1.87A13.94 13.94 0 0016.003 30C23.72 30 30 23.72 30 16.003 30 8.28 23.72 2 16.003 2zm0 25.471a11.899 11.899 0 01-6.088-1.671l-.436-.26-4.355 1.11 1.147-4.228-.285-.447A11.862 11.862 0 014.13 16.003c0-6.545 5.328-11.873 11.873-11.873 6.544 0 11.872 5.328 11.872 11.873 0 6.544-5.328 11.468-11.872 11.468zm6.51-8.887c-.357-.178-2.11-1.04-2.438-1.16-.328-.118-.567-.178-.806.179-.238.356-.923 1.16-1.132 1.398-.208.238-.417.268-.774.09-.357-.18-1.506-.555-2.868-1.77-1.06-.944-1.775-2.11-1.983-2.467-.208-.357-.022-.55.156-.727.16-.16.357-.417.536-.625.178-.209.238-.357.357-.596.119-.238.06-.447-.03-.625-.09-.179-.806-1.943-1.104-2.659-.29-.698-.585-.603-.806-.614l-.686-.012c-.238 0-.625.09-.952.447-.327.357-1.25 1.22-1.25 2.975s1.28 3.452 1.458 3.69c.179.238 2.52 3.847 6.107 5.394.853.368 1.519.588 2.038.753.856.272 1.636.234 2.252.142.687-.102 2.11-.863 2.408-1.697.297-.834.297-1.549.208-1.698-.089-.148-.327-.237-.685-.415z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;